import { ListChecks } from 'lucide-react'

import type { Selection } from '@/components/selection'
import { Button } from '@/components/ui'

import { trackCountLabel } from './labels'

export interface SelectAllBarProps {
  /** Ids of every row currently rendered, in display order. */
  ids: number[]
  selection: Selection<number>
  /** True when the list is paginated and the server still has more rows. */
  hasMore?: boolean
}

/**
 * "Select all" and an honest note about what "all" means. A paginated list can
 * only select what has been loaded, and saying so beats a user believing they
 * just picked a library of 3000 tracks.
 */
export function SelectAllBar({ ids, selection, hasMore = false }: SelectAllBarProps) {
  const everythingSelected = ids.length > 0 && ids.every((id) => selection.isSelected(id))

  return (
    <div className="mb-1 flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
      <Button
        size="sm"
        variant="secondary"
        disabled={ids.length === 0 || everythingSelected}
        onClick={() => selection.selectAll(ids)}
      >
        <ListChecks className="h-4 w-4" aria-hidden="true" />
        Select all
      </Button>

      <p className="text-sm text-text-muted">
        {hasMore
          ? `${trackCountLabel(ids.length)} loaded so far. Scroll down to load more.`
          : `${trackCountLabel(ids.length)} in this list.`}
      </p>
    </div>
  )
}
